
export interface ArticleItem {
  category_id: string;
  category_name: string;
  created: string;
  href: string;
  id: string;
  is_liveupdates: string;
  location: string;
  news_location: string;
  post_featured_image: string;
  post_featured_image_thumb: string;
  post_slug: string;
  post_title: string;
  slug: string;
  type: string;
  user: string;
  userid: string;
  userimage: string;
  views: string;
  description: string;
  isLive:any;
  extra_images:any;
}

export interface ArticleItemProps {
  darkMode: any;
  fontSize: any;  
  inlineView: boolean;
  title:any
  articles: ArticleItem[];
}



export interface VideoItem {
  id: string;
  post_title: string;
  post_featured_image: string;
  post_featured_image_thumb: string;
  location: string;
  created: string;
  user: string;  
  post_slug:string;
}

export interface VideoboxProps {
  darkMode: boolean;
  fontSize: string;  
  inlineView: boolean;
  videos: VideoItem[];
}

export interface VideoProps {
  category_id: string;
  category_name: string;
  created: string;
  href: string;
  id: string;
  is_liveupdates: string;
  location: string;
  news_location: string;
  post_featured_image: string;
  post_featured_image_thumb: string;
  post_slug: string;
  post_title: string;
  slug: string;
  type: string;
  user: string;
  userid: string;
  userimage: string;
  views: string;
}

export interface VideoState {
  videos: VideoProps[];
}




export interface ArticleDetailsProps {
  success: string;
  storiesyoumayinterested: any;
  image_alt: any;
  image_caption: any;
  articles: any;
  meta_type: any;
  page_type: any;
  meta_pagetitle: any;
  meta_title: any;
  social_share_description: any;
  meta_description: any;
  meta_tags: any;
  meta_keyword: any;
  meta_logo: any;
  meta_url: any;
  meta_datePublished: any;
  meta_dateModified: any;
  news_datePublished: any;
  snippetpublisheddate: any;
  snippetmodifieddate: any;
  as_date: any;
  astime: any;
  pagetype: any;
  meta_image: any;
  meta_articlebody: any;
}

export const initailArticleState: ArticleDetailsProps = {
   success: '',
  storiesyoumayinterested: null,
  image_alt: null,
  image_caption: null,
  articles: null,
  meta_type: null,
  page_type: null,
  meta_pagetitle: null,
  meta_title: null,
  social_share_description: null,
  meta_description: null,
  meta_tags: null,
  meta_keyword: null,
  meta_logo: null,
  meta_url: null,
  meta_datePublished: null,
  meta_dateModified: null,
  news_datePublished: null,
  snippetpublisheddate: null,
  snippetmodifieddate: null,
  as_date: null,
  astime: null,
  pagetype: null,
  meta_image: null,
  meta_articlebody: null
}

